import { Route } from "@angular/router";

import { DsV3Plan, notExternalOrParticipatingEntity } from "../../../core/guards";
import { viewDataEntryPagesGuards } from "../_guards";

export const ACTIVITY_ACTUALS_ROUTES: Route[] = [
  {
    path: "activity",
    canActivate: [notExternalOrParticipatingEntity, ...viewDataEntryPagesGuards, DsV3Plan()],
    children: [
      {
        path: "",
        data: {
          title: "data_entry.activity_actuals",
          breadcrumb: "data_entry.activity_actuals",
        },
        loadComponent: () =>
          import("./activity-actuals-list/activity-actuals-list").then((e) => e.ActivityActualsListComponent),
      },
      {
        path: "edit/:id",
        data: {
          title: "data_entry.edit_title",
          breadcrumb: "data_entry.edit_title",
        },
        loadComponent: () =>
          import("./activity-actuals-editor/activity-actuals-editor").then((e) => e.ActivityActualsEditorComponent),
      },
    ],
  },
];
